export type DiscussionVersionNumberProps = {
  onVersionClick?: () => void;
  discussionVersion: number;
};

export const DiscussionVersionNumber = ({ onVersionClick, discussionVersion }: DiscussionVersionNumberProps) => {
  const versionText = `V${discussionVersion}`;

  if (!discussionVersion) {
    return null;
  }

  return !onVersionClick ? (
    <div className="font-bold ads:text-metadata text-10 text-gray-10">{versionText}</div>
  ) : (
    <button
      className="font-bold ads:text-metadata text-10 text-gray-10 hover:underline"
      onClick={onVersionClick}
      type="button"
    >
      {versionText}
    </button>
  );
};
